import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'linaria';
import { Button } from 'components/buttons/button';
import { getPublishedDate } from 'common/utilities';
import { breakpointLargeHandset } from 'common/constants';
import VisibilitySensor from 'components/visibility-sensor/visibility-sensor';
import { Trans } from 'next-i18next';
const AttributionWrapper = "a11m02ot";

function FollowPublisher({
  leadIn,
  text,
  url,
  handleImpression,
  handleClick
}) {
  return <VisibilitySensor onVisible={handleImpression}>
      <div className="publisher-follow" data-cy="follow-publisher">
        <p>{leadIn}</p>
        <Button variant="secondary" onClick={handleClick} href={url}
      /* eslint-disable-next-line */
      target="_blank">
          {text}
        </Button>
      </div>
    </VisibilitySensor>;
}

function PublisherInfo({
  logoWide,
  publishedAt,
  name
}) {
  const publishedDate = getPublishedDate(publishedAt);
  return name ? <>
      <hr />
      {logoWide ? <img src={logoWide} data-cy="publisher-img" alt={`Logo for ${name}`} /> : null}
      <p>
        <Trans i18nKey="discover:publisher-attribution">
          This post originally appeared on {{
          name
        }} and was published {{
          publishedDate
        }}. This
          article is republished here with permission.
        </Trans>
      </p>
    </> : null;
}

function PublisherAttribution({
  publisher,
  publishedAt,
  handlePublisherImpression,
  handlePublisherClick
}) {
  function handleImpression() {
    handlePublisherImpression(publisher.name);
  }

  function handleClick() {
    handlePublisherClick(publisher.name);
  }

  return publisher ? <cite className={AttributionWrapper}>
      <PublisherInfo logoWide={publisher.logoWide} publishedAt={publishedAt} name={publisher.name} />
      {publisher.articleCta ? <FollowPublisher {...publisher.articleCta} handleImpression={handleImpression} handleClick={handleClick} /> : null}
    </cite> : null;
}

PublisherAttribution.propTypes = {
  /**
   * Publisher object that includes the publisher name, logo, and custom button object
   */
  publisher: PropTypes.shape({
    logoWide: PropTypes.string,
    name: PropTypes.string,
    articleCta: PropTypes.object
  }),

  /**
   * Published date as a string: e.g 4/1/2019
   */
  publishedAt: PropTypes.string,

  /**
   * Callback function to fire an event on impression
   */
  handlePublisherImpression: PropTypes.func,

  /**
   * Callback function to fire an event on click
   */
  handlePublisherClick: PropTypes.func
};
PublisherAttribution.defaultProps = {
  publisher: null,

  handlePublisherImpression() {},

  handlePublisherClick() {}

};
export { PublisherAttribution };

require("./publisher-attribution.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./publisher-attribution.js");